import { render, staticRenderFns } from "./paidList.vue?vue&type=template&id=40a3d607"
import script from "./paidList.vue?vue&type=script&lang=ts"
export * from "./paidList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports